import React from "react";
import { ShieldAlert } from "lucide-react";
import QuestionCompletion from "./QuestionCompletion";
import QuestionDissertation from "./QuestionDissertation";
import QuestionClassement from "./QuestionClassement";
import QuestionGaming from "./QuestionGaming";
import QuestionMatching from "./QuestionMatching";
import QuestionQcm from "./QuestionQcm";
import QuestionQcu from "./QuestionQcu";
import QuestionYesNo from "./QuestionYesNo";

const SUPPORTED_TYPES = new Set(["QCU", "QCM", "OUI_NON", "COMPLETEMENT", "DISSERTATION", "MATCHING", "CLASSEMENT", "GAMING"]);
const isSupportedV1 = (question) => SUPPORTED_TYPES.has(question?.typeQuestion);

export default function QuestionRenderer({ question, value, onChange, disabled, reviewMode = false }) {
    if (!isSupportedV1(question)) {
        return (
            <div className="qr-unsupported">
                <ShieldAlert size={18} />
                <div>
                    <strong>Ce type de question sera disponible dans une prochaine version.</strong>
                    <p>Le player V1 continue de fonctionner, mais cette question n'est pas encore interactive.</p>
                </div>
            </div>
        );
    }

    if (reviewMode) {
        return null;
    }

    switch (question.typeQuestion) {
        case "QCU":
            return <QuestionQcu question={question} value={value} onChange={onChange} disabled={disabled} />;
        case "QCM":
            return <QuestionQcm question={question} value={value} onChange={onChange} disabled={disabled} />;
        case "OUI_NON":
            return <QuestionYesNo question={question} value={value} onChange={onChange} disabled={disabled} />;
        case "COMPLETEMENT":
            return <QuestionCompletion question={question} value={value} onChange={onChange} disabled={disabled} />;
        case "DISSERTATION":
            return <QuestionDissertation question={question} value={value} onChange={onChange} disabled={disabled} />;
        case "MATCHING":
            return <QuestionMatching question={question} value={value} onChange={onChange} disabled={disabled} />;
        case "CLASSEMENT":
            return <QuestionClassement question={question} value={value} onChange={onChange} disabled={disabled} />;
        case "GAMING":
            return <QuestionGaming question={question} value={value} onChange={onChange} disabled={disabled} />;
        default:
            return null;
    }
}
